<template>
  <el-form
      ref="form"
      :model="form"
      :rules="rules"
      v-loading="isBusy"
      element-loading-spinner="el-icon-loading"
      label-width="250"
  >
    <div>
      <p>Structure of the import file:</p>
      <ol>
        <li>First name</li>
        <li>Last name</li>
        <li>Filemaker ID</li>
        <li>Phone number #1</li>
        <li>Phone number #2 (optional)</li>
        <li>Phone number #3 (optional)</li>
        <li>Phone number #4 (optional)</li>
        <li>Phone number #5 (optional)</li>
        <li>Phone number #6 (optional)</li>
      </ol>
    </div>
    <el-form-item label="Import File:" prop="file">
      <div v-if="isFileSelected">
        <em>{{ this.fileInfo }}</em>
        <span class="btn btn-link btn-link-red px-1" @click="clearFile"><i class="fas fa-times-circle"></i></span>
      </div>
      <file-input v-else v-model="form.file" v-slot:default="{clickHandler}">
        <span @click.prevent="clickHandler" class="btn btn-link btn-link-purple px-0"><i class="fas fa-folder-open"></i></span>
      </file-input>
    </el-form-item>
    <el-form-item prop="replace_filemaker_id">
      <!-- 1/0 rather than true/false: FormData sends strings and Laravel's boolean rule rejects "true". -->
      <el-checkbox v-model="form.replace_filemaker_id" :true-label="1" :false-label="0">Replace Filemaker ID</el-checkbox>
      <el-tooltip
          effect="light"
          content="If a contact already has a different Filemaker ID, replace it with the filled one from the file. Otherwise the existing ID is kept."
          placement="top-start"
      >
        <i class="far fa-question-circle ml-1"></i>
      </el-tooltip>
    </el-form-item>
    <el-form-item>
      <button class="btn btn-purple" @click.prevent="store" :disabled="!isFileSelected">Process</button>
    </el-form-item>
  </el-form>
</template>

<script>
import BaseImportForm from './base-import-form';

export default {
  extends: BaseImportForm,

  data() {
    return {
      form: {
        file: null,
        type: null,
        replace_filemaker_id: 0,
      },
      rules: {
        file: [{validator: this.fieldExternalValidator}],
        replace_filemaker_id: [{validator: this.fieldExternalValidator}],
      },
    };
  },

  methods: {
    /**
     * @param {Object} model
     */
    initForm({file = null, type = null, replace_filemaker_id = 0}) {
      this.form = {file, type, replace_filemaker_id};
    },
  },
}
</script>
